import { render, staticRenderFns } from "./sysuser_edit.vue?vue&type=template&id=48a7900c&scoped=true"
import script from "./sysuser_edit.vue?vue&type=script&lang=js"
export * from "./sysuser_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7900c",
  null
  
)

export default component.exports